var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui container"},[_vm._v("\n    Activate your account\n    "),_c('button',{staticClass:"ui button",on:{"click":function($event){return _vm.activate()}}},[_vm._v("Activate")])])}
var staticRenderFns = []

export { render, staticRenderFns }